// extracted by mini-css-extract-plugin
export default {"editForm":"style_editForm__xJ58W","desc":"style_desc__z47Qy"};